import React, { useState, useEffect } from "react";
import "./create-auction.styles.scss";

// import IndividualItem from "../../components/slot-individual-item/slot-individual-item.component";

import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import {
  ExclamationCircleOutlined,
  LeftOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import CustomSelect from "../../components/custom-select/custom-select.component";

import { ArrayFormat } from "../../models/common.types";

import {
  getMaterialCodes,
  getSlotAuctions,
  postAuction,
  postUploadAuction,
} from "../../services/auction-services";
import { Dispatch } from "redux";

import { createStructuredSelector } from "reselect";

import {
  selectBypassBD,
  selectBranches,
  selectCrops,
  selectVarieties,
  selectSelectedCrop,
  selectTC,
  selectCurrentPage,
  selectSelectedBranch,
  selectSaudhaType,
  selectMinQty,
  selectHubs,
  selectRebates,
  selectDivisionList,
  selectBagtypeList,
  selectDefaultParams,
} from "../../redux/common/common.selectors";
import { connect, useDispatch } from "react-redux";

import {
  Form,
  Input,
  Button,
  Select,
  Radio,
  DatePicker,
  Spin,
  message,
  Modal,
  Checkbox,
  Upload,
  Breadcrumb,
  Flex,
  Typography,
  Space,
  Table,
  InputNumber,
  Switch,
} from "antd";
import {
  setBypassBD,
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import {
  getAuctionType,
  getLocationService,
  getRebateService,
} from "../../services/common-services";
import { canUserAccess } from "../../utils/utils";
import { FeatureCodes } from "../../constants/data-constants";
import { selectUserData } from "../../redux/user/user.selectors";
import { useLocation } from "react-router";
const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
dayjs.extend(isSameOrBefore);

interface ISlots {
  slot_id: number;
  qty_rqd: number;
  rebate_matrix_id: string;
}
interface ISlotsGet {
  slot_id: number;
  is_active: boolean | null;
  qty_rqd: number | null | any;
  qty_fulfilled: number | null;
  rebate_id: string | null;
  max_price: any | null;
  need_date: string | null;
  start_time: string;
  auction_freeze_period: number;
}
interface IFormData {
  crop_id: number;
  branch_id: number;
  hub_id: number | null;
  variety_id: number | null;
  division: number | null;
  saudha_type: number | null;
  claim_type: number | null;
  role_type: any;
  max_price: number | null;
  min_price: number | null;
  need_date: string | null;
  slots: Array<any> | null;
  remarks: string | null;
  buying_decision_id: number | null;
  withBd: boolean | null;
}

const CreateAuction: React.FC = (props: any) => {
  const {
    branches,
    varieties,
    selectedCrop,
    isBypassedBD,
    crops,
    currentpage,
    selectedBranch,
    setSelectedCrop,
    setSelectedBranchIndex,
    selectDefaultParams,
    minQty,
    saudhaType,
    hubs,
    rebates,
    divisions,
    bagTypeList,
    userData,
  } = props;
  const formDefault = {
    crop_id: null,
    branch_id: null,
    hub_id: null,
    del_loc_sap_code: null,
    bag_type: null,
    material_code: null,
    variety_id: null,
    division: null,
    saudha_type: null,
    claim_type: null,
    role_type: null,
    max_price: null,
    min_price: null,
    need_date: null,
    slots: [],
    remarks: "",
    buying_decision_id: null,
    withBd: null,
  };
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<any>(formDefault);
  const [isHubLoading, setIsHubLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [fileList, setFileList] = useState<any>([]);
  const [isSlotAuctionLoading, setIsSlotAuctionLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [isPosting, setIsPosting] = useState(false);
  const [rebateList, setRebateList] = useState<any>([]);
  const [auctionTypes, setAuctionType] = useState<any>([]);
  const [locationList, setLocation] = useState<any>([]);
  const [materialList, setMaterialList] = useState<any>([]);
  const [form] = Form.useForm();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.includes("/TN/viewauction/create") && isBypassedBD) {
      setFormData({
        ...formDefault,
        crop_id: selectedCrop,
        branch_id: selectedBranch,
        saudha_type: +saudhaType,
      });
      setLocation([]);
    }
  }, [currentpage, isBypassedBD]);

  //to fire API when the combination is selected
  useEffect(() => {
    if (formData.crop_id != null && formData.branch_id != null) {
      getAuctionData({
        crop_id: formData.crop_id,
        branch_id: formData.branch_id,
      });
    }
    if (
      formData.hub_id != null &&
      formData.variety_id != null &&
      formData.claim_type != null &&
      formData.division != null
    ) {
      const params = {
        crop_id: formData.crop_id,
        branch_id: formData.branch_id,
        hub_id: formData.hub_id,
        variety_id: formData.variety_id,
        claim_type: formData.claim_type,
        division: formData.division,
      };
      const rebateParams = {
        crop_id: formData.crop_id,
        branch_id: formData.branch_id,
        variety_id: formData.variety_id,
        division: divisions.filter(
          (item: any) => item.id === formData.division
        )[0].name,
      };
      getVarietyData(rebateParams);
      getSlotAuctionDetails(params);
      getMaterialData({
        variety_id: formData.variety_id,
        auction_division: divisions.filter(
          (item: any) => item.id === formData.division
        )[0].name,
      });
      // } else {
      // setFormData({
      //   ...formData,
      //   slots: [],
      // });
    }
  }, [
    formData.hub_id,
    formData.variety_id,
    formData.claim_type,
    formData.division,
    formData.crop_id,
    formData.branch_id,
  ]);
  const columns = [
    {
      title: "Slot",
      dataIndex: "slot_id",
      key: "slot_id",
      width: 120,
      render: (_, __) => {
        return (
          <Space direction="vertical">
            <Text>Slot {__.slot_number}</Text>
            <Text style={{ fontSize: 10 }}>
              {dayjs(__?.start_time, "HH:mm:ss").format("hh:mm A")} -{" "}
              {dayjs(__?.end_time, "HH:mm:ss").format("hh:mm A")}
            </Text>
          </Space>
        );
      },
    },
    {
      title: "Rake Auction",
      dataIndex: "auction_type",
      key: "auction_type",
      width: 90,
      render: (_, __) => {
        return (
          // <Switch
          //   onChange={(value: any) =>
          //     onSlotValueChanged(value, __.slot_id, "auction_type")
          //   }
          //   checkedChildren="Yes"
          //   unCheckedChildren="No"
          //   value={_}
          // />
          <Form.Item
            name={["rows", __.slot_id, "auction_type"]}
            style={{ margin: 0 }}
          >
            <Select
              onChange={(value: any) =>
                onSlotValueChanged(value, __.slot_id, "auction_type")
              }
              disabled={
                dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                (__.auction_freeze_period &&
                  dayjs(
                    dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                    "HH:mm:ss"
                  ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
              }
              options={auctionTypes}
              // options={[
              //   { value: 1, label: "Normal" },
              //   { value: 2, label: "Rake" },
              //   { value: 3, label: "Container Rake Bid" },
              // ]}
            />
          </Form.Item>
        );
      },
    },
    {
      title: `Slot Quantity (${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "qty_rqd",
      key: "qty_rqd",
      width: 120,
      render: (_, record: any) => {
        return (
          <>
            <Form.Item
              name={["rows", record.slot_id, "qty_rqd"]}
              style={{ margin: 0 }}
            >
              {record.auction_type == 3 ? (
                <Select
                  onChange={(value: any) =>
                    onSlotValueChanged(value, record.slot_id, "qty_rqd")
                  }
                  disabled={
                    record.qty_fulfilled !== null ||
                    dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                    (record.auction_freeze_period &&
                      dayjs(
                        dayjs("HH:mm:ss").add(
                          record.auction_freeze_period,
                          "minutes"
                        ),
                        "HH:mm:ss"
                      ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
                  }
                  options={[
                    {
                      value: Number(
                        selectDefaultParams?.rj_container_bid_full_rake
                      ),
                      label: selectDefaultParams?.rj_container_bid_full_rake,
                    },
                    {
                      value: Number(
                        selectDefaultParams?.rj_container_bid_half_rake
                      ),
                      label: selectDefaultParams?.rj_container_bid_half_rake,
                    },
                  ]}
                />
              ) : (
                <InputNumber
                  min={0}
                  // style={{ width: "50%" }}
                  onChange={(value: any) =>
                    onSlotValueChanged(value, record.slot_id, "qty_rqd")
                  }
                  onBlur={(e: any) => {
                    const rows = form.getFieldValue("rows");
                    if (
                      record.auction_type == 2 &&
                      !/^\d+(\.5)?$/.test(
                        `${e.target.value / selectDefaultParams.full_rake}`
                      )
                    ) {
                      message.warning("Enter Valid Quantity...!");
                      rows[record.slot_id].qty_rqd = 0; // clear value
                      form.setFieldsValue({ rows });
                      onSlotValueChanged(0, record.slot_id, "qty_rqd");
                    }
                  }}
                  disabled={
                    record.qty_fulfilled !== null ||
                    dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
                    (record.auction_freeze_period &&
                      dayjs(
                        dayjs("HH:mm:ss").add(
                          record.auction_freeze_period,
                          "minutes"
                        ),
                        "HH:mm:ss"
                      ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
                  }
                />
              )}
            </Form.Item>
            {record.auction_type == 2 && (
              <Text style={{ fontSize: 10 }}>
                Rake Count:{" "}
                {/^\d+(\.5)?$/.test(`${_ / selectDefaultParams.full_rake}`)
                  ? _ / selectDefaultParams.full_rake
                  : 0}
              </Text>
            )}
          </>
        );
      },
    },
    {
      title: "Rebate Name",
      dataIndex: "rebate_id",
      key: "rebate_id",
      width: 180,
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "rebate_id"]}
          // rules={[{ required: true, message: "Please enter Rebate Name" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "rebate_id")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss"))) ||
              formData.claim_type === 2
            }
          >
            {rebateList.map((item: any) => (
              <Option
                value={item.rebate_id}
                id={item.rebate_id}
                key={item.rebate_id}
              >
                {item.rebate_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCrop)?.unit
      })`,
      dataIndex: "max_price",
      key: "max_price",
      width: 120,
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "max_price"]}
          // rules={[{ required: true, message: "Please enter Max Price" }]}
          style={{ margin: 0 }}
        >
          <InputNumber
            min={0}
            style={{ width: "100%" }}
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "max_price")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
          />
        </Form.Item>
      ),
    },
    {
      title: "Need Date",
      dataIndex: "need_date",
      key: "need_date",
      width: 140,
      render: (_, record) => (
        <Form.Item
          name={["rows", record.slot_id, "need_date"]}
          // rules={[{ required: true, message: "Please enter Need Date" }]}
          style={{ margin: 0 }}
        >
          <DatePicker
            value={[record.need_date && dayjs(record.need_date, "YYYY-MM-DD")]}
            style={{ width: "100%" }}
            onChange={(value: any) =>
              onSlotValueChanged(value, record.slot_id, "need_date")
            }
            format={"YYYY-MM-DD"}
            disabledDate={(d) => d.isBefore(dayjs())}
            disabled={
              record.qty_fulfilled !== null ||
              dayjs(record.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (record.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(
                    record.auction_freeze_period,
                    "minutes"
                  ),
                  "HH:mm:ss"
                ).isAfter(dayjs(record.start_time, "HH:mm:ss")))
            }
          />
        </Form.Item>
      ),
    },
    {
      title: "Material Code",
      dataIndex: "material_code",
      key: "material_code",
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "material_code"]}
          // rules={[{ required: true, message: "Please enter Material Code" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "material_code")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
          >
            {materialList &&
              materialList.map((item: any) => (
                <Option value={item.value} id={item.id} key={item.id}>
                  {item.value}
                </Option>
              ))}
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Bag Type",
      dataIndex: "bag_type",
      key: "bag_type",
      render: (_, __) => (
        <Form.Item
          name={["rows", __.slot_id, "bag_type"]}
          // rules={[{ required: true, message: "Please enter Bag Type" }]}
          style={{ margin: 0 }}
        >
          <Select
            onChange={(value: any) =>
              onSlotValueChanged(value, __.slot_id, "bag_type")
            }
            disabled={
              __.qty_fulfilled !== null ||
              dayjs(__.start_time, "HH:mm:ss").isBefore(dayjs()) ||
              (__.auction_freeze_period &&
                dayjs(
                  dayjs("HH:mm:ss").add(__.auction_freeze_period, "minutes"),
                  "HH:mm:ss"
                ).isAfter(dayjs(__.start_time, "HH:mm:ss")))
            }
          >
            {bagTypeList &&
              bagTypeList.map((item: any) => (
                <Option value={item.id} id={item.id} key={item.name}>
                  {item.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      ),
    },
  ];
  const getVarietyData = async (params: any) => {
    try {
      const rebateListResponse = await getRebateService(params);
      if (rebateListResponse.data.status) {
        setRebateList(rebateListResponse.data.data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getAuctionData = async (params: any) => {
    try {
      const auctionTypeResponse = await getAuctionType(params);
      if (auctionTypeResponse.data.status) {
        setAuctionType(
          auctionTypeResponse.data.data.map((item: any) => {
            return {
              value: item.auction_type_id,
              label: item.auction_type_name,
            };
          })
        );
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getMaterialData = async (params: any) => {
    try {
      const response = await getMaterialCodes(params);
      if (response.data.status) {
        const data = response.data.data.map((item: any) => {
          return {
            id: item.pk_id,
            value: item.material_code,
          };
        });
        setMaterialList(data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };
  const getSlotAuctionDetails = async (params: any) => {
    setIsSlotAuctionLoading(true);
    setFormData({ ...formData, slots: [] });
    form.resetFields();
    try {
      const response = await getSlotAuctions(params);
      if (response.data.status) {
        var edit = true;
        response.data.data.slots.map((item: any) => {
          item.need_date = dayjs().add(7, "days").format("YYYY-MM-DD");
          // item.auction_type = item.auction_type == 1 ? false : true;
          if (dayjs(item.start_time, "HH:mm:ss").isSameOrBefore(dayjs())) {
            edit = false;
          }
        });
        const slotData = response.data.data.slots;
        const objectSlots = Object.fromEntries(
          slotData.map((item) => [
            item.slot_id,
            { ...item, need_date: dayjs(item.need_date, "YYYY-MM-DD") },
          ])
        );
        form.setFieldsValue({
          rows: objectSlots,
        });
        setFormData({
          ...formData,
          slots: response.data.data.slots,
          max_price: response.data.data.max_price,
          min_price: response.data.data.min_price,
          need_date: response.data.data.need_date,
          remarks: response.data.data.remarks,
          withBd: response.data.data.with_bd,
        });
      }
    } catch (error) {
      setIsSlotAuctionLoading(false);
    }
    setIsSlotAuctionLoading(false);
  };

  const setSaudhaAndHub = async () => {
    setIsSpinning(false);
  };
  const getLocationDetails = async (value) => {
    try {
      const locaitonResponse = await getLocationService({
        territory_id: value,
        crop_id: formData.crop_id,
      });
      setLocation(locaitonResponse.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const onChange = async (value: number, selected: string) => {
    switch (selected) {
      case "hub":
        setFormData({ ...formData, hub_id: value, del_loc_sap_code: "" });
        getLocationDetails(value);
        break;
      case "variety":
        setFormData({ ...formData, variety_id: value });
        break;
      case "del_loc_sap_code":
        setFormData({ ...formData, del_loc_sap_code: value });
        break;
      case "crop":
        setFormData({
          ...formData,
          crop_id: value,
          variety_id: null,
          branch_id: null,
          hub_id: null,
          del_loc_sap_code: null,
        });
        setSelectedCrop(value);
        break;
      default:
        break;
    }
  };

  const onSlotValueChanged = (
    value: number,
    slotId: number,
    changedField: string | any
  ) => {
    let slotChangedData = formData.slots;
    slotChangedData !== null &&
      slotChangedData.map((item: any) => {
        if (item.slot_id === slotId) {
          if (changedField == "need_date")
            item[changedField] = value
              ? dayjs(value).format("YYYY-MM-DD")
              : null;
          else item[changedField] = value ? value : null;
          item["is_edit"] = true;
          if (
            changedField !== "rebate_id" &&
            changedField !== "max_price" &&
            changedField !== "bag_type" &&
            changedField !== "material_code" &&
            changedField !== "auction_type" &&
            changedField !== "need_date"
          ) {
            if (value < Number(minQty)) {
              item["showError"] = true;
            } else {
              item["showError"] = false;
            }
          }
        }
        return item;
      });
    setFormData({ ...formData, slots: slotChangedData });
  };

  function showPromiseConfirm() {
    confirm({
      title: "Override buying decision ?",
      icon: <ExclamationCircleOutlined />,
      content:
        "An auction with buying decision exist, do you want to override ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        createAuction();
      },
      onCancel() {
        setFormData(formDefault);
      },
    });
  }

  const createAuctionClicked = () => {
    setIsPosting(true);
    if (formData.withBd) {
      showPromiseConfirm();
    } else createAuction();
    setIsPosting(false);
    // getParamsFnWithOutLoad(formData.branch_id, formData.crop_id, true, true);
  };

  const createAuction = async () => {
    const postData: any = [];
    if (formData.slots?.length === 0) {
      message.warning("Can not find any slots.");
      return false;
    } else if (formData.slots && formData.slots?.length !== 0) {
      let isFieldDataEmpty: boolean = true;
      for (let i = 0; i < formData.slots?.length; i++) {
        if (
          formData.slots[i].is_active &&
          formData.slots[i].need_date &&
          (formData.slots[i].qty_rqd || formData.slots[i].max_price)
        ) {
          if (!formData.slots[i].is_edit) {
            continue;
          }
          const maxPrice = varieties?.filter(
            (item: any) => item.id === formData.variety_id
          )[0].maxPrice;
          const minPrice = varieties?.filter(
            (item: any) => item.id === formData.variety_id
          )[0].minPrice;
          if (
            dayjs(
              dayjs(dayjs(), "HH:mm:ss").add(
                formData.slots[i].auction_freeze_period,
                "minutes"
              ),
              "HH:mm:ss"
            ).isAfter(dayjs(formData.slots[i].start_time, "HH:mm:ss"))
          ) {
            message.warning(
              `Auction cannot be created ${formData.slots[i].auction_freeze_period} minute(s) before the slot start time.`
            );
            return false;
          } else if (
            formData.claim_type === 1 &&
            formData.slots[i].rebate_id === null
          ) {
            message.warning("Please enter valid rebate id.");
            return false;
          } else if (
            formData.slots[i].qty_rqd === null ||
            isNaN(formData.slots[i].qty_rqd)
          ) {
            message.warning("Please enter valid Slot qty.");
            return false;
          } else if (
            formData.slots[i].max_price === null ||
            isNaN(formData.slots[i].max_price)
          ) {
            message.warning("Please enter max price...");
            return false;
          } else if (
            formData.slots[i].max_price <= minPrice ||
            formData.slots[i].max_price >= maxPrice
          ) {
            message.warning(
              `Max price should be between the range ${minPrice} (₹/${
                crops?.find((item) => item.id == selectedCrop)?.unit
              }) to ${maxPrice} (₹/${
                crops?.find((item) => item.id == selectedCrop)?.unit
              })...`
            );
            return false;
          } else if (
            isNaN(formData.slots[i].max_price) ||
            formData.slots[i].max_price <= 0
          ) {
            message.warning("Enter a valid max price...");
            return false;
          } else if (
            formData.slots[i].need_date === "" ||
            formData.slots[i].need_date === null ||
            formData.slots[i].need_date === undefined
          ) {
            message.warning("Please enter need date...");
            return false;
          } else if (
            formData.slots[i].material_code === "" ||
            formData.slots[i].material_code === null ||
            formData.slots[i].material_code === undefined
          ) {
            message.warning("Please select Material...");
            return false;
          } else if (
            formData.slots[i].bag_type === "" ||
            formData.slots[i].bag_type === null ||
            formData.slots[i].bag_type === undefined
          ) {
            message.warning("Please select Bag type...");
            return false;
          }
          // formData.slots[i].auction_type = formData.slots[i].auction_type
          //   ? 2
          //   : 1;
          postData.push({
            ...formData.slots[i],
            id: i,
            end_time: formData.slots[i].bid_ends_on,
            rebate_matrix_id: formData.slots[i].rebate_id,
            need_date: dayjs(formData.slots[i].need_date, "YYYY-MM-DD").format(
              "YYYY-MM-DD"
            ),
          });
          postData
            .filter((item: any) => item.id === i)
            .map((item: any) => {
              item.qty_fulfilled =
                item.qty_fulfilled === null ? 0 : item.qty_fulfilled;
              delete item.bid_ends_on;
              delete item.rebate_id;
              delete item.auction_freeze_period;
              delete item.slot_number;
              delete item.start_time;
              delete item.showError;
              delete item.id;
              delete item.is_edit;
            });
          isFieldDataEmpty = false;
        } else if (
          formData.slots[i].qty_rqd === null &&
          formData.slots[i].max_price === null &&
          formData.slots[i].need_date ===
            dayjs().add(7, "days").format("YYYY-MM-DD")
        ) {
          continue;
        } else {
          if (formData.slots[i].is_active) {
            message.warning("Please enter valid slot details...");
            return false;
          }
          continue;
        }
      }
      if (!isFieldDataEmpty) {
        setFormData((prev: IFormData) => {
          const modifiedData: any = {
            ...prev,
            saudha_type: prev.saudha_type,
            slots: postData,
            role_type: [15],
            withBd: false,
            min_price: null,
            buying_decision_id: null,
          };
          delete modifiedData.allSlots;
          delete modifiedData.need_date;
          delete modifiedData.normal_auction_exists;
          delete modifiedData.roleType;
          delete modifiedData.saudaType;
          delete modifiedData.total_qty;
          delete modifiedData.varietyName;
          delete modifiedData.hub_name;
          delete modifiedData.max_price;
          (async (modifiedData) => {
            try {
              const postResponse = await postAuction(modifiedData);
              if (postResponse.data.status) {
                message.success("Auction created / updated successfully");
                const params = {
                  crop_id: formData.crop_id,
                  branch_id: formData.branch_id,
                  hub_id: formData.hub_id,
                  variety_id: formData.variety_id,
                  claim_type: formData.claim_type,
                  division: formData.division,
                };
                getSlotAuctionDetails(params);
              } else {
                message.error(
                  postResponse.data.message || "Something went wrong :("
                );
              }
            } catch (err: any) {
              console.log(err);
              message.error(
                err.response.data.message || "Something went wrong :("
              );
            }
          })(modifiedData);
          return prev;
        });
        return true;
      } else {
        message.error("Please fill slot datas to create/update auctions.");
        return false;
      }
    }
  };
  const handleUpload = async () => {
    try {
      if (fileList.length === 0) {
        message.warning("Please select a file to upload.");
        return;
      }
      const cropName = crops.find(
        (item: { id: number; name: string }) => item.id === formData.crop_id
      )?.name;
      const branchName = branches.find(
        (item: { id: number; name: string }) => item.id === formData.branch_id
      )?.name;
      const formFile = new FormData();
      formFile.append("file", fileList[0]);
      formFile.append("crop_name", cropName);
      formFile.append("mail_branch", branchName);
      const postResponse = await postUploadAuction(formFile);
      setModal(false);
      setFileList([]);
      message.success(`Uploading file: ${fileList[0].name}`);
    } catch (error) {
      message.error("Unable to upload...");
    }
  };
  const beforeUpload = (file: any) => {
    const allowedExtensions = [".xlsx"];
    const fileExt = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

    if (!allowedExtensions.includes(fileExt)) {
      message.error("You can only upload Excel files (.xlsx)");
      return false;
      // return Upload.LIST_IGNORE;
    }

    setFileList([file]); // Only allow one file
    return false; // Prevent auto upload
  };

  return (
    <div className="create-auction">
      <Spin spinning={isSpinning}>
        <Breadcrumb
          items={[
            {
              title: (
                <>
                  <LeftOutlined />
                  <span>Create Auction</span>
                </>
              ),
              onClick: () => dispatch(setBypassBD(!isBypassedBD)),
            },
            {
              title: isBypassedBD ? "Create New Auction" : "Copy Auction",
            },
          ]}
        />
        <Space>
          <Text type="danger">
            <b>NOTE:</b> Auction cannot be created{" "}
            {formData?.slots[0]?.auction_freeze_period || 5} minute(s) before
            the slot start time
          </Text>
        </Space>
        <Title level={5} style={{ textAlign: "start", marginBlock: 10 }}>
          Select Hub and Crop Details
        </Title>
        <Flex gap={"small"} wrap>
          <Flex style={{ textAlign: "left" }} wrap gap={"small"} vertical>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Select Crop
            </div>
            <Select
              style={{ width: "200px" }}
              placeholder="Select Crop"
              value={formData.crop_id ? formData.crop_id : undefined}
              onChange={(value, option) => onChange(value, "crop")}
            >
              {crops.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Flex>
          <Flex style={{ textAlign: "left" }} wrap gap={"small"} vertical>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Select Variety
            </div>
            <Select
              style={{ width: "200px" }}
              placeholder="Select Variety"
              value={formData.variety_id ? formData.variety_id : undefined}
              onChange={(value, option) => onChange(value, "variety")}
            >
              {varieties &&
                varieties.length &&
                varieties.map((item: ArrayFormat) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </Flex>
          <Flex style={{ textAlign: "left" }} wrap gap={"small"} vertical>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Place/City
            </div>
            <Select
              style={{ width: "200px" }}
              placeholder="Place/City"
              value={formData.branch_id ? formData.branch_id : undefined}
              onChange={(value, option) => {
                setFormData((prev) => ({
                  ...prev,
                  branch_id: value,
                  hub_id: null,
                  del_loc_sap_code: null,
                }));
                setLocation([]);
                setSelectedBranchIndex(value);
              }}
              showSearch
              filterOption={(input, option: any) =>
                option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={branches.map((item: any) => ({
                value: item.id,
                label: item.name,
              }))}
            />
          </Flex>
          <Flex style={{ textAlign: "left" }} wrap gap={"small"} vertical>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Select Hub
            </div>
            <Select
              style={{ width: "200px" }}
              placeholder="Select Hub"
              value={formData.hub_id ? formData.hub_id : undefined}
              onChange={(value, option) => onChange(value, "hub")}
              loading={isHubLoading}
              disabled={isHubLoading}
              showSearch
              filterOption={(input, option: any) =>
                option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {hubs.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Flex>
          <Flex style={{ textAlign: "left" }} wrap gap={"small"} vertical>
            <div className="label">Select Delivery Location</div>
            <Select
              style={{ width: "200px" }}
              placeholder="Select Delivery Location"
              allowClear
              value={
                formData.del_loc_sap_code
                  ? formData.del_loc_sap_code
                  : undefined
              }
              onChange={(value, option) => onChange(value, "del_loc_sap_code")}
            >
              {locationList &&
                locationList.map((item: any) => (
                  <Option
                    key={item.del_loc_sap_code}
                    value={item.del_loc_sap_code}
                  >
                    {item.del_loc_name}
                  </Option>
                ))}
            </Select>
          </Flex>
          <Flex gap={"small"}>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Division
            </div>
            <Radio.Group
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
              value={formData.division}
              onChange={(e) => {
                setFormData({ ...formData, division: e.target.value });
              }}
            >
              {divisions &&
                divisions.map((item: any) => (
                  <Radio value={item.id} id={item.id} key={item.id}>
                    {item.name}
                  </Radio>
                ))}
            </Radio.Group>
          </Flex>
          <Flex gap={"small"}>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Claim Type
            </div>
            <Radio.Group
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
              value={formData.claim_type}
              onChange={(e) => {
                setFormData({ ...formData, claim_type: e.target.value });
              }}
            >
              <Radio value={1}>Claim</Radio>
              <Radio value={2}>No Claim</Radio>
            </Radio.Group>
          </Flex>
          <Flex gap={"small"}>
            <div className="label">
              <label style={{ color: "red" }}>*</label> Sauda Type
            </div>
            <Radio.Group
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
              value={formData.saudha_type}
              onChange={(e) => {
                setFormData({ ...formData, saudha_type: e.target.value });
              }}
            >
              <Radio value={1}>Net basis</Radio>
              <Radio value={2}>Gross basis</Radio>
            </Radio.Group>
          </Flex>
        </Flex>
        <Flex vertical>
          {/* <div className="form-items">
              <div className="label noteText">
                <b>
                  {formData.slots !== undefined &&
                  formData.slots !== null &&
                  formData.slots.length
                    ? ` NOTE: Auction cannot be created ${formData.slots[0].auction_freeze_period} minute(s) before the slot start time`
                    : ""}
                </b>
              </div>
            </div> */}
          <Form
            form={form}
            initialValues={{
              rows: formData.slots
                .filter(
                  (item: any) => item.is_active && item.is_active === true
                )
                .map((row) => ({
                  ...row,
                  need_date: dayjs(row.need_date) || dayjs(),
                })),
            }}
          >
            <Table
              rowKey="slot_id"
              size="small"
              columns={columns}
              dataSource={formData.slots.filter(
                (item: any) => item.is_active && item.is_active === true
              )}
              scroll={{ x: "max-content" }}
            />
          </Form>
          {/* <div className="slots-container">
              {formData.slots !== null && formData.slots.length > 0 ? (
                formData.slots
                  .filter(
                    (item: any) => item.is_active && item.is_active === true
                  )
                  .map((item: any, index: number) => {
                    return (
                      <IndividualItem
                        key={index}
                        index={index}
                        slotId={item.slot_id}
                        cropId={formData.crop_id}
                        branchId={formData.branch_id}
                        slotNumber={item.slot_number}
                        onChangeFn={onSlotValueChanged}
                        requiredQty={item.qty_rqd}
                        minQtyShow={
                          item.showError === undefined ? false : item.showError
                        }
                        sysParametersData={minQty}
                        purchasedQty={item.qty_fulfilled}
                        rebateId={item.rebate_id}
                        startTime={item.start_time}
                        auctionFreezePeriod={item.auction_freeze_period}
                        endTime={item.end_time}
                        rebateList={rebateList}
                        bag_type={item.bag_type}
                        bagTypeList={bagTypeList}
                        materialList={materialList}
                        material_code={item.material_code}
                        claim={formData.claim_type}
                        needDate={item.need_date}
                        maxPrice={item.max_price}
                      />
                    );
                  })
              ) : formData.hub_id !== null &&
                formData.variety_id !== null &&
                formData.claim_type !== null &&
                formData.division !== null ? (
                <div className="no-slots-container">No slots available...</div>
              ) : (
                <div className="no-slots-container">
                  Select Hub - Variety - Claim Type - Division
                </div>
              )}
            </div> */}
          <Flex justify="flex-start" gap={10} style={{ paddingTop: 10 }}>
            <div className="label">Remarks : {"   "}</div>
            <TextArea
              value={formData.remarks === null ? undefined : formData.remarks}
              showCount
              autoSize={{ minRows: 2, maxRows: 6 }}
              maxLength={30}
              onChange={(e) => {
                const text = e.target.value.replace(/[^a-zA-Z0-9\s,._-]/g, "");
                setFormData({
                  ...formData,
                  remarks: text,
                });
              }}
              style={{ width: "80vh" }}
            />
          </Flex>
        </Flex>
        <div className="bottom-container">
          <Button
            loading={isPosting}
            onClick={createAuctionClicked}
            disabled={canUserAccess(
              userData,
              FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
            )}
          >
            Create Auction
          </Button>
          {process.env.REACT_APP_ENV != "uat" &&
            crops?.find((item) => item.id == selectedCrop)?.is_upload == 1 &&
            !canUserAccess(userData, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS) && (
              <Button
                loading={isPosting}
                onClick={() => setModal(true)}
                disabled={canUserAccess(
                  userData,
                  FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                )}
              >
                Upload
              </Button>
            )}
        </div>
      </Spin>
      <Modal
        className="temporal-modal"
        title="Upload"
        open={modal}
        closable={false}
        maskClosable={false}
        okText="Upload"
        cancelText="Cancel"
        style={{ textAlign: "center" }}
        centered
        okButtonProps={{
          style: { backgroundColor: "#20346a", border: 0 },
        }}
        cancelButtonProps={{
          danger: true,
          type: "dashed",
        }}
        onOk={handleUpload}
        onCancel={() => {
          setFileList([]);
          setModal(false);
        }}
      >
        <div style={{ color: "black" }}>
          <Upload
            beforeUpload={beforeUpload}
            fileList={fileList}
            accept=".xlsx"
            onRemove={() => setFileList([])}
          >
            <Button icon={<UploadOutlined />}>Select Excel File</Button>
          </Upload>
        </div>
      </Modal>
    </div>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCrop: (index: number) => dispatch(setSelectedCrop(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  isBypassedBD: selectBypassBD,
  branches: selectBranches,
  userData: selectUserData,
  crops: selectCrops,
  varieties: selectVarieties,
  selectedCrop: selectSelectedCrop,
  selectDefaultParams: selectDefaultParams,
  TCHtmlString: selectTC,
  currentpage: selectCurrentPage,
  selectedBranch: selectSelectedBranch,
  minQty: selectMinQty,
  saudhaType: selectSaudhaType,
  hubs: selectHubs,
  rebates: selectRebates,
  divisions: selectDivisionList,
  bagTypeList: selectBagtypeList,
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateAuction);
